import { NativeBridge } from "@swiggy-private/native-bridge";

let bridgeSdk: NativeBridge | null = null;
export const initBridgeSdk = (sdk?: NativeBridge): NativeBridge => {
    if (bridgeSdk && !sdk) {
        return bridgeSdk;
    }

    bridgeSdk = sdk || new NativeBridge(null);
    return bridgeSdk;
};

export const getBridgeSdk = (): NativeBridge => bridgeSdk || initBridgeSdk();
